import axios from "axios";

// const base_path = getBaseUrl();
const base_path = window.APP_CONFIG?.BASE_URL;
// const base_path = process.env.REACT_APP_API_URL;

//---------opening stock apis-----------------

export const getStockByBranch = async (branch) => {
  const response = await axios.get(
    `${base_path}/Api/OpeningStock/GetAllByBranchID?globalBranchID=${branch?.guid}`
  );

  return response.data;
};

// Create a new or edit opening stock
export const addEditStock = async (stockData) => {
  const response = await axios.post(
    `${base_path}/Api/OpeningStock/SaveOrUpdate`,
    JSON.stringify(stockData)
  );
  return response;
};

//delete opening stock
export const deleteStock = async (stockData) => {
  const response = await axios.post(
    `${base_path}/Api/OpeningStock/Delete`,
    stockData
  );
  return response;
};
